<script lang="ts">
	import DefaultButton from '../../basic/buttons/DefaultButton.svelte';
	import DefaultTextInput from '../../basic/input/DefaultTextInput.svelte';
	import InputLabel from '../../basic/input/InputLabel.svelte';
	import Modal from '../../basic/modal/Modal.svelte';
	import ModalHeader from '../../basic/modal/ModalHeader.svelte';
	import { _ } from 'svelte-i18n';

	let code: string = $state('');
	let showRecovery: boolean = $state(false);
	let recoveryCode: string = $state('');
	let showError: boolean = $state(false)

	interface Props {
		verify: (code: string) => Promise<number>;
		recover: (code: string) => Promise<void>;
		requestClose: () => void;
	}

	let { verify, recover, requestClose }: Props = $props();

	async function handleCodeVerification() {
		let statusCode = await verify(code);

		showError = statusCode == 404
	}

	function handleCodeRecovery() {
		recover(recoveryCode);
	}
</script>

<Modal onModalClose={requestClose}>
	{#snippet header()}
		<div>
			<ModalHeader text={$_('login.two_factor_auth.lbl_header')}></ModalHeader>
		</div>
	{/snippet}
	{#snippet content()}
		<div>
			<div class="flex flex-col gap-2">
				<!--Code-->
				<InputLabel label={$_('settings.admin.two_factor_auth.lbl_code')}></InputLabel>
				<DefaultTextInput
					focusOnStart={true}
					disabled={showRecovery}
					propertyName="twoFactorAuthCode"
					bind:value={code}
					onKeyup={(e) => e.key === 'Enter' && handleCodeVerification()}
				/>

				{#if showError}
					<p class="text-red">{$_("login.err_wrong_2fa_code")}</p>
				{/if}
				
				<button
					onclick={() => {
						showRecovery = !showRecovery;
					}}
					class="text-sm text-secondary-200 dark:text-secondary-500"
					>{$_('settings.admin.lbl_use_backup_code')}</button
				>
			</div>
			{#if showRecovery}
				<div class="flex flex-col gap-2">
					<!--Code-->
					<InputLabel label={$_('settings.admin.two_factor_auth.lbl_recovery')}></InputLabel>
					<DefaultTextInput propertyName="twoFactorAuthCode" bind:value={recoveryCode} />
				</div>
			{/if}
			<div class="flex gap-2 mt-6 mb-2 justify-end">
				<DefaultButton secondary={true} text={$_('general.bt_close')} onClick={requestClose}
				></DefaultButton>
				{#if showRecovery}
					<!--Recovery button-->
					<DefaultButton
						warning={true}
						disabled={recoveryCode.length < 25}
						text={$_('settings.admin.two_factor_auth.bt_recover')}
						onClick={handleCodeRecovery}
					/>
				{:else}
					<!--Verify button-->
					<DefaultButton
						disabled={code.length < 6}
						text={$_('settings.admin.two_factor_auth.bt_verify')}
						onClick={handleCodeVerification}
					/>
				{/if}
			</div>
		</div>
	{/snippet}
</Modal>
